import styled from 'styled-components';

export const RewardHistoryContainerStyled = styled.div``;
